import { upperFirst } from 'lodash'
import React from 'react'
import { Element, Icon } from 'react-bulma-components'
import { Mission } from '../../../api/missions'
import { WorkPeriod } from '../../../api/work-periods'
import { formatCompleteDate } from '../../../utils/date'
import Avatar from '../../avatar/avatar'
import { EmployerServiceIcon, JobTitleIcon } from '../../icons'
import PageTitle from '../../pages/page-title'

interface WorkPeriodPageTitleProps {
  workPeriod: WorkPeriod
  children?: React.ReactNode
  onServiceEdit?: () => void
}

const WorkPeriodPageTitle: React.FC<WorkPeriodPageTitleProps> = ({
  workPeriod,
  children,
  onServiceEdit,
}) => (
  <PageTitle
    title={upperFirst(formatCompleteDate(workPeriod.start.date))}
    subTitle={
      <>
        <b>
          <Icon.Text mr={5}>
            <Avatar user={workPeriod.user} dataTest="work-period-details-worker-name" />
          </Icon.Text>
        </b>
        <Icon.Text mr={5}>
          <Icon mr={1}>
            <EmployerServiceIcon />
          </Icon>
          {onServiceEdit ? (
            <Element
              renderAs="a"
              onClick={onServiceEdit}
              data-test="work-period-details-service-name"
            >
              {workPeriod.service.name}
            </Element>
          ) : (
            <Element data-test="work-period-details-service-name" renderAs="span">
              {workPeriod.service.name}
            </Element>
          )}
        </Icon.Text>
        <Icon.Text mr={5}>
          <Icon mr={1}>
            <JobTitleIcon />
          </Icon>
          <Element data-test="work-period-details-job-title-name" renderAs="span">
            {workPeriod.mission.jobTitle.name}
          </Element>
        </Icon.Text>
      </>
    }
  >
    {children}
  </PageTitle>
)

export default WorkPeriodPageTitle
